import { CloudUpload } from 'lucide-react';

function CustomInput({ label, type = 'text', className = '', onChange, placeholder, isError, errorMessage, ...props }) {
  const isFileType = type === 'file';

  return (
    <div className="custom-input">
      {label && <label>{label}</label>}
      <div className={isFileType ? 'file-input' : ''}>
        <input
          type={type}
          onChange={onChange}
          placeholder={placeholder}
          className={`${isError ? 'error-input' : ''} form-control ${className}`}
          {...props}
        />
        {isFileType ? (
          <div className="file-input-text">
            <CloudUpload />
            <span>{placeholder}</span>
          </div>
        ) : null}
      </div>
      {isError && errorMessage && <p>{errorMessage}</p>}
    </div>
  );
}

export default CustomInput;
